export default __webpack_public_path__ + "static/media/mftv_more.36b376b4.svg";